import { Group, Paper, RegionCargando, Skeleton, Stack } from "@/components/ui";
import { useMisCanales } from "../hooks/use-perfil-notificaciones";
import { CardCelular } from "./CardCelular";
import { CardPreferencias } from "./CardPreferencias";
import { CardPush } from "./CardPush";
import { CardTelegram } from "./CardTelegram";

/**
 * Pestaña "Notificaciones" de Mi perfil (spec §6): dónde recibo avisos (celular, Telegram,
 * notificaciones del navegador) y qué notificaciones quiero silenciar.
 */
export function TabNotificaciones() {
  const { data: canales, isLoading } = useMisCanales();
  if (isLoading || !canales) return <TabNotificacionesSkeleton />;
  return (
    <Stack gap="md">
      <CardCelular celular={canales.celular} />
      <CardTelegram telegram={canales.telegram} />
      <CardPush push={canales.push} />
      <CardPreferencias />
    </Stack>
  );
}

/**
 * Primera carga · las tres tarjetas de canal (título, ayuda, campo + botón).
 * Preferencias NO se pinta aquí: se monta al llegar los canales y muestra su
 * propia lista de filas con switch mientras carga.
 */
function TabNotificacionesSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando canales de notificación…">
      <Stack gap="md">
        {[0, 1, 2].map((i) => (
          <Paper key={i} withBorder padding="lg" aria-hidden="true">
            <Stack gap="sm">
              <Group gap="xs">
                <Skeleton height={18} width={18} />
                <Skeleton height={14} width={i === 2 ? 180 : 110} />
              </Group>
              <Skeleton height={12} width="80%" />
              <Group gap="xs">
                <Skeleton height={36} width={256} className="max-w-full" />
                <Skeleton height={36} width={96} />
              </Group>
            </Stack>
          </Paper>
        ))}
      </Stack>
    </RegionCargando>
  );
}
